export default __webpack_public_path__ + "static/media/startup4.905baa92.gif";